export default function Error() {
  return <div>Error page</div>;
}
